(() => {
  const NS = 'http://www.w3.org/2000/svg';
  const ZONES = {
    front: { left: 31, top: 24, width: 38, height: 57 },
    back: { left: 31, top: 24, width: 38, height: 57 },
    left: { left: 8, top: 27, width: 23, height: 21 },
    right: { left: 69, top: 27, width: 23, height: 21 }
  };
  const FONTS = {
    impact: 'Impact, Arial Narrow, sans-serif',
    modern: 'Arial, Helvetica, sans-serif',
    serif: 'Georgia, Times New Roman, serif',
    typewriter: 'Courier New, monospace',
    script: 'Brush Script MT, Segoe Script, cursive'
  };
  const BODY_PATH = 'M205 112 C240 88 282 69 316 56 C332 71 352 78 380 78 C408 78 428 71 444 56 C478 69 520 88 555 112 L700 184 C714 191 719 206 712 220 L650 326 C644 338 629 343 617 336 L555 301 L555 516 C555 539 537 557 514 557 L246 557 C223 557 205 539 205 516 L205 301 L143 336 C131 343 116 338 110 326 L48 220 C41 206 46 191 60 184 Z';

  const clamp = (value, min, max) => Math.min(max, Math.max(min, Number(value) || 0));

  /* Meranie textu rovnakým spôsobom ako v konfigurátore (ao-shirt-customizer.js).
     Náhľad v košíku predtým bral `textSize` doslova a nezmenšoval text na
     veľkosť potlačovej plochy, hoci konfigurátor to robí. Dlhý text tak
     v konfigurátore sedel, ale v košíku pretiekol cez tričko. */
  const measureContext = (() => {
    try { return document.createElement('canvas').getContext('2d'); }
    catch (_) { return null; }
  })();

  function textLines(p) {
    const raw = String(p?.text || '');
    return (p?.uppercase ? raw.toUpperCase() : raw).split(/\r?\n/);
  }

  function fittedFontSize(p, key, baseSize) {
    const z = ZONES[key];
    if (!z || !measureContext) return Math.max(1.5, baseSize);
    const zoneWidth = 760 * z.width / 100;
    const zoneHeight = 600 * z.height / 100;
    const lines = textLines(p);
    const family = FONTS[p.font] || FONTS.impact;
    const weight = p.bold ? 900 : 500;
    const style = p.italic ? 'italic' : 'normal';
    let size = baseSize;
    measureContext.font = `${style} ${weight} ${size}px ${family}`;
    const tracking = size * (Number(p.letterSpacing) || 0) / 100;
    const wordGap = size * (Number(p.wordSpacing) || 0) / 100;
    const widthScale = Math.max(.45, Number(p.textWidth || 100) / 100);
    const measuredWidth = Math.max(1, ...lines.map((line) => {
      const raw = line || ' ';
      const width = measureContext.measureText(raw).width;
      const letters = Math.max(0, raw.length - 1) * tracking;
      const spaces = (raw.match(/ /g) || []).length * wordGap;
      return (width + letters + spaces) * widthScale;
    }));
    const measuredHeight = Math.max(1, lines.length) * size * ((Number(p.lineHeight) || 106) / 100);
    const radians = Math.abs(Number(p.textRotation) || 0) * Math.PI / 180;
    const cos = Math.abs(Math.cos(radians));
    const sin = Math.abs(Math.sin(radians));
    const rotatedWidth = measuredWidth * cos + measuredHeight * sin;
    const rotatedHeight = measuredWidth * sin + measuredHeight * cos;
    size *= Math.min(1, zoneWidth * 0.96 / rotatedWidth, zoneHeight * 0.93 / rotatedHeight);
    return Math.max(1.5, size);
  }

  function node(name, attrs = {}) {
    const el = document.createElementNS(NS, name);
    Object.entries(attrs).forEach(([key, value]) => el.setAttribute(key, String(value)));
    return el;
  }

  function positionHasContent(p) {
    return !!(p && ((p.textEnabled && String(p.text || '').trim()) || (p.photoEnabled && p.photoUrl)));
  }

  function selectedMain(positions) {
    if (positions.front) return 'front';
    if (positions.back) return 'back';
    if (positions.left) return 'left';
    if (positions.right) return 'right';
    return 'front';
  }

  function addPhoto(svg, key, p) {
    if (!p?.photoEnabled || !p.photoUrl) return;
    const z = ZONES[key];
    if (!z) return;
    const x = 760 * (z.left + z.width * clamp(p.photoX ?? 50, 0, 100) / 100) / 100;
    const y = 600 * (z.top + z.height * clamp(p.photoY ?? 50, 0, 100) / 100) / 100;
    const width = 760 * z.width * clamp(p.photoSize ?? 45, 5, 95) / 10000;
    const aspect = Math.max(.15, Number(p.imageAspect) || 1);
    const height = width / aspect;
    const rotation = Number(p.photoRotation) || 0;
    const crop = p.cropPercent;
    const sourceAspect = Math.max(.15, Number(p.sourceAspect) || aspect);

    if (crop && Number.isFinite(Number(crop.left)) && Number.isFinite(Number(crop.top)) && Number.isFinite(Number(crop.right)) && Number.isFinite(Number(crop.bottom))) {
      const left = clamp(crop.left, 0, 99.5);
      const top = clamp(crop.top, 0, 99.5);
      const right = clamp(crop.right, left + .5, 100);
      const bottom = clamp(crop.bottom, top + .5, 100);
      const sourceW = sourceAspect * 100;
      const sourceH = 100;
      const nested = node('svg', {
        x: x - width / 2,
        y: y - height / 2,
        width,
        height,
        viewBox: `${sourceW * left / 100} ${sourceH * top / 100} ${sourceW * (right - left) / 100} ${sourceH * (bottom - top) / 100}`,
        preserveAspectRatio: 'none',
        overflow: 'hidden',
        transform: `rotate(${rotation} ${x} ${y})`
      });
      nested.appendChild(node('image', { href: p.photoUrl, x: 0, y: 0, width: sourceW, height: sourceH, preserveAspectRatio: 'none' }));
      svg.appendChild(nested);
      return;
    }

    svg.appendChild(node('image', {
      href: p.photoUrl,
      x: x - width / 2,
      y: y - height / 2,
      width,
      height,
      preserveAspectRatio: 'xMidYMid meet',
      transform: `rotate(${rotation} ${x} ${y})`
    }));
  }

  function addText(svg, key, p) {
    const raw = String(p?.text || '').trim();
    if (!p?.textEnabled || !raw) return;
    const z = ZONES[key];
    if (!z) return;
    const x = 760 * (z.left + z.width * clamp(p.textX ?? 50, 0, 100) / 100) / 100;
    const y = 600 * (z.top + z.height * clamp(p.textY ?? 50, 0, 100) / 100) / 100;
    const sleeve = key === 'left' || key === 'right';
    const baseSize = 760 * z.width / 100 * clamp(p.textSize ?? 42, 5, 100) / 100 * (sleeve ? .34 : .40);
    const fontSize = fittedFontSize(p, key, baseSize);
    const lineHeight = fontSize * (Number(p.lineHeight || 106) / 100);
    /* Bez orezania na štyri riadky — päťriadkový návrh sa v košíku tichom
       zobrazoval neúplný, takže náhľad nesúhlasil s objednávkou. */
    const lines = textLines(p);
    const text = node('text', {
      x: 0,
      y: -((lines.length - 1) * lineHeight / 2),
      fill: p.color || '#111111',
      'font-family': FONTS[p.font] || FONTS.impact,
      'font-size': fontSize,
      'font-weight': p.bold ? 900 : 500,
      'font-style': p.italic ? 'italic' : 'normal',
      'letter-spacing': fontSize * (Number(p.letterSpacing) || 0) / 100,
      'word-spacing': fontSize * (Number(p.wordSpacing) || 0) / 100,
      'text-anchor': 'middle',
      'dominant-baseline': 'middle',
      transform: `translate(${x} ${y}) rotate(${Number(p.textRotation) || 0}) scale(${Math.max(.45, Number(p.textWidth || 100) / 100)} 1)`
    });
    lines.forEach((line, index) => {
      const tspan = node('tspan', { x: 0, dy: index === 0 ? 0 : lineHeight });
      tspan.textContent = line;
      text.appendChild(tspan);
    });
    svg.appendChild(text);
  }

  function addDesignLayers(svg, key, p) {
    if (!p) return;
    if (p.layerOrder === 'photo-top') {
      addText(svg, key, p);
      addPhoto(svg, key, p);
    } else {
      addPhoto(svg, key, p);
      addText(svg, key, p);
    }
  }

  function renderPreview(root) {
    if (!root) return;
    /* Príznak sám o sebe nestačí. Košík sa po zmene prekresľuje zo servera
       „morfovaním“ existujúcich uzlov — atribúty sa vrátia na serverovú
       podobu a vykreslené SVG zmizne, ale žiadny nový uzol nepribudne.
       Preto sa pýtame priamo na obsah: keď stage chýba, kreslíme znova. */
    if (root.dataset.aoPreviewReady === 'true' && root.querySelector('.ao-cart-shirt-preview__stage')) return;
    let config = {};
    try { config = JSON.parse(root.dataset.config || '{}'); } catch (_) {}
    const positions = config.positions || {};
    const main = selectedMain(positions);
    const shirtColor = String(config.shirtColor || '').toLowerCase().includes('ier') || String(config.shirtColor || '').toLowerCase().includes('black') ? '#151515' : '#f7f5f0';
    const seam = shirtColor === '#151515' ? '#5f5f5f' : '#c7c2ba';

    const stage = document.createElement('div');
    stage.className = 'ao-cart-shirt-preview__stage';
    /* Kreslí sa do sústavy 760 × 600, ale samotné tričko zaberá len
       obdĺžnik 45,56 → 715,557. Zvyšok bol prázdny okraj, kvôli ktorému
       náhľad v košíku vyzeral zbytočne malý. viewBox je preto orezaný
       tesne okolo trička; súradnice potlače sa nemenia. */
    const svg = node('svg', { viewBox: '36 46 688 521', role: 'img', 'aria-label': main === 'back' ? 'Náhľad zadnej strany trička' : 'Náhľad prednej strany trička' });
    svg.appendChild(node('path', { d: BODY_PATH, fill: shirtColor, stroke: seam, 'stroke-width': 4 }));
    if (main !== 'back') {
      svg.appendChild(node('path', {
        d: 'M316 56 C327 122 433 122 444 56',
        fill: 'none', stroke: seam, 'stroke-width': 4, 'stroke-linecap': 'round'
      }));
    }

    if (positions[main]) addDesignLayers(svg, main, positions[main]);
    ['left', 'right'].forEach(key => {
      if (!positions[key] || key === main) return;
      addDesignLayers(svg, key, positions[key]);
    });

    stage.appendChild(svg);
    root.replaceChildren(stage);
    if (main === 'front' && positionHasContent(positions.back)) {
      const badge = document.createElement('span');
      badge.className = 'ao-cart-shirt-preview__badge';
      badge.textContent = '+ zadná strana';
      root.appendChild(badge);
    } else if (main === 'back') {
      const badge = document.createElement('span');
      badge.className = 'ao-cart-shirt-preview__badge';
      badge.textContent = 'zadná strana';
      root.appendChild(badge);
    }
    root.dataset.aoPreviewReady = 'true';
  }

  function renderAll(scope = document) {
    scope.querySelectorAll?.('[data-ao-cart-shirt-preview]').forEach(renderPreview);
  }

  function boot(scope = document) {
    renderAll(scope);
  }

  const scheduleBoot = (scope = document) => {
    if (typeof requestAnimationFrame === 'function') {
      requestAnimationFrame(() => boot(scope));
    } else {
      setTimeout(() => boot(scope), 0);
    }
  };

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => scheduleBoot());
  else scheduleBoot();

  window.addEventListener('load', () => scheduleBoot());
  window.addEventListener('pageshow', () => scheduleBoot());
  document.addEventListener('visibilitychange', () => {
    if (!document.hidden) scheduleBoot();
  });

  const needsRender = (element) => (
    element instanceof Element
    && element.matches?.('[data-ao-cart-shirt-preview]')
    && !element.querySelector('.ao-cart-shirt-preview__stage')
  );

  const observer = new MutationObserver(records => {
    for (const record of records) {
      for (const added of record.addedNodes) {
        if (!(added instanceof Element)) continue;
        if (added.matches?.('[data-ao-cart-shirt-preview]') || added.querySelector?.('[data-ao-cart-shirt-preview]')) {
          boot(added.matches?.('[data-ao-cart-shirt-preview]') ? added.parentElement || document : added);
        }
      }
      // Prekreslenie košíka môže obsah náhľadu iba vyprázdniť, bez pridania
      // nového uzla — vtedy zachytíme cieľ mutácie, nie pridané uzly.
      const target = record.target;
      if (needsRender(target)) renderPreview(target);
      else if (target instanceof Element && target.querySelector?.('[data-ao-cart-shirt-preview]')) {
        target.querySelectorAll('[data-ao-cart-shirt-preview]').forEach((node) => {
          if (needsRender(node)) renderPreview(node);
        });
      }
    }
  });
  observer.observe(document.documentElement, { childList: true, subtree: true, attributes: true, attributeFilter: ['data-config', 'data-ao-preview-ready'] });

  /* Poistka: po každej zmene košíka prekresli, čo sa vyprázdnilo. */
  ['cart:update', 'cart:updated', 'cart:refresh', 'cart:change'].forEach((name) => {
    document.addEventListener(name, () => scheduleBoot(), { passive: true });
  });
})();
